export { ResizeObserverDirective } from './resize-observer.directive';
